import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Box } from "@vk-hr-tek/ui/Box";
import { Typography } from "@vk-hr-tek/ui/Typography";
import { CopyButton } from "@vk-hr-tek/ui/CopyButton";
const SubmitError = (t0)=>{
    const $ = c(11);
    const { submitError, withDescription } = t0;
    const t1 = submitError && submitError.title ? submitError.title : "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A. \u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0432 \u0447\u0430\u0442 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u0438 \u0441\u043E\u043E\u0431\u0449\u0438\u0442\u0435 \u043A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438";
    let t2;
    if ($[0] !== t1) {
        t2 = /*#__PURE__*/ jsx(Typography, {
            color: "accent.text.error",
            variant: "body3",
            children: t1
        });
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== submitError || $[3] !== withDescription) {
        t3 = withDescription && submitError.description && /*#__PURE__*/ jsx(Typography, {
            color: "accent.text.error",
            variant: "body3",
            children: submitError.description
        });
        $[2] = submitError;
        $[3] = withDescription;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== submitError) {
        t4 = (null == submitError ? void 0 : submitError.traceId) && /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            mt: "8",
            gap: "8",
            children: [
                /*#__PURE__*/ jsx(Typography, {
                    color: "text.light.tertirary",
                    variant: "body3",
                    children: `Код ошибки: ${submitError.traceId}`
                }),
                /*#__PURE__*/ jsx(CopyButton, {
                    valueToCopy: submitError.traceId,
                    size: "16"
                })
            ]
        });
        $[5] = submitError;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ jsxs(Box, {
            children: [
                t2,
                t3,
                t4
            ]
        });
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
};
export { SubmitError };
